module.exports = __webpack_public_path__ + "img/1p.cdc8d292.png";